// Presentation only: never coerce masked, missing or invalid financial data to zero.
export function amountValue(value) {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  if (typeof value !== 'string' || !/^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(value.trim())) return null
  const number = Number(value.replace(/,/g, ''))
  return Number.isFinite(number) ? number : null
}

export function metricText(value) {
  if (value === undefined || value === null || value === '') return '—'
  const amount = amountValue(value)
  return amount === null ? String(value) : amount.toLocaleString('zh-CN', { maximumFractionDigits: 2 })
}

export function incomeChart(recharge, revenue) {
  const values = [amountValue(recharge), amountValue(revenue)]
  if (values.some(value => value === null)) return null
  const low = Math.min(0, ...values)
  const high = Math.max(0, ...values) || (low === 0 ? 1 : 0)
  const span = high - low || 1
  const y = value => 28 + (high - value) / span * 124
  const baseline = y(0)
  return {
    baseline,
    bars: values.map((value, index) => ({
      value, x: 66 + index * 108, y: Math.min(y(value), baseline),
      height: Math.abs(y(value) - baseline), labelY: value < 0 ? y(value) + 15 : y(value) - 9,
      text: metricText(value)
    })),
    ticks: [high, (high + low) / 2, low].map(value => ({
      y: y(value),
      text: Math.abs(value) >= 10000 ? metricText(value / 10000) + '万' : metricText(value)
    }))
  }
}
